var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10h-3.5a6.5 6.5 0 01-13 0H2c0 5.523 4.477 10 10 10z",
    fill: "url(#loader_svg__paint0_linear_9_11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10h-3.5a6.5 6.5 0 00-13 0H2C2 6.477 6.477 2 12 2z",
    fill: "url(#loader_svg__paint1_linear_9_11)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loader_svg__paint0_linear_9_11",
    x1: 5.5,
    y1: 12,
    x2: 22,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5,
    stopColor: props.fill
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: props.fill
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loader_svg__paint1_linear_9_11",
    x1: 18.5,
    y1: 12,
    x2: 5.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: props.fill
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5,
    stopColor: props.fill
  }))));
}
export default SvgLoader;